import React from 'react';
import { useTheme } from 'react-native-paper';

import useTypeModeColors, {
  UseTypeModeColorsProps,
} from '../../hooks/use-type-mode-colors';

export type UseToggleButtonColors = {
  selected?: boolean;
} & UseTypeModeColorsProps;

export const useToggleButtonColors = ({
  selected,
  mode,
  type = 'primary',
  ghost,
  color,
  disabled,
}: UseToggleButtonColors) => {
  const { colors } = useTheme();
  const {
    labelColor: _labelColor,
    borderColor: _borderColor,
    backgroundColor,
  } = useTypeModeColors({
    mode,
    type,
    ghost,
    color,
    disabled,
  });

  const borderColor = React.useMemo(() => {
    if (
      (mode === 'outlined' || mode === 'contained' || (ghost && !disabled)) &&
      !selected
    ) {
      return colors.border;
    }
    return disabled && mode === 'text' ? colors.transparent : _borderColor;
  }, [
    _borderColor,
    colors.border,
    colors.transparent,
    disabled,
    ghost,
    selected,
    mode,
  ]);

  const labelColor = React.useMemo(() => {
    if (
      (mode === 'contained' || mode === 'outlined') &&
      !selected &&
      !disabled &&
      !ghost
    ) {
      return colors.dark1;
    }
    return !disabled && !selected && !ghost ? colors[type] : _labelColor;
  }, [_labelColor, colors, disabled, ghost, selected, mode, type]);

  const noSelectedBackgroundColor = React.useMemo(() => {
    if (mode === 'contained' && !ghost) {
      return colors.white;
    }

    if (color) {
      return color;
    }

    return colors.transparent;
  }, [color, colors.transparent, colors.white, ghost, mode]);

  return {
    borderColor,
    labelColor,
    backgroundColor,
    noSelectedBackgroundColor,
  };
};
